import React from "react"
import { Skeleton, Typography } from "antd"
import VSpace from "../../common/VSpace"
import PaymentMethodDisplay from "../PaymentMethodDisplay"
import { useGetPaymentMethodsOnFileQuery } from "../../../domain/invoicing/invoicingQueries"

const CustomerPaymentMethodsList = ({ customerId }: { customerId: number }) => {
  const query = useGetPaymentMethodsOnFileQuery(customerId)

  if (query.isLoading) {
    return <Skeleton active />
  }

  const paymentMethods = query.data ?? []

  if (!paymentMethods.length) {
    return <Typography.Text type="secondary">No payment methods on file.</Typography.Text>
  }

  return <VSpace>
    {paymentMethods.map(summary => <div key={summary.id} style={cardStyle}>
      <PaymentMethodDisplay summary={summary} />
    </div>)}
  </VSpace>
}

export default CustomerPaymentMethodsList

const cardStyle: React.CSSProperties = {
  borderColor: '#00000026',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '12px',
  padding: '8px',
}
